// no shims in the browser when imported via conditional export
